import styled from "styled-components"

export default styled.p`
  width: 100%;
  text-align: left;
  margin-top: 10px;
  font-size: 14px;
  margin-bottom: 20px;
`
